import DatePicker from "react-datepicker";

function DatePickers(props) {
    const {from_date, to_date, setFromDate, setToDate} = props
   
    return(
        <div className="datepickers">
            <span>Przedział czasowy od&nbsp;</span>
            <DatePicker
                selected={from_date}
                onChange={date => setFromDate(date)}
                dateFormat="dd/MM/yyyy"
            />
        do&nbsp;
        <DatePicker
            selected={to_date}
            onChange={date => setToDate(date) }
            minDate={from_date}
            dateFormat="dd/MM/yyyy"
        />
        </div>
    )
}

export default DatePickers